import { useEffect, useState } from "react";
import Filter from "./Filter";
import AdminService from "../../../services/admin.service";
import { useAdmin } from "../../../context/admin";
import { PassengerAuthorization } from "../../../types/common.types";
import List from "./List";
import { useGlobal } from "../../../context/global";

export default function Authorizations() {
    const { setIsLoading } = useGlobal()
    const { currentDay, endDay } = useAdmin()

    const [authorizations, setAuthorizations] = useState<PassengerAuthorization[]>([])
    const [filter, setFilter] = useState<'authorized' | 'rejected' | 'pending' | undefined>(undefined)

    useEffect(() => {
        async function fetchAuthorizations() {
            setIsLoading(true)
            const data = await (await AdminService.getPassengerAuthorizations(currentDay, endDay)).data
            setIsLoading(false)
            if (filter) {
                setAuthorizations(data.filter((auth: PassengerAuthorization) => auth.status === filter))
                return
            }
            setAuthorizations(data)
        }
        fetchAuthorizations()
    }, [currentDay, endDay, filter])
    
    return (
        <>
            <Filter filter={filter} setFilter={setFilter}/>
            <List data={authorizations}/>
        </>
    )
}